import module from '../module';
import Constants from '../../../utils/CommonConstants';


class StickyPanelDirectiveController {
    constructor(scope, element, rootScope) {

        this._rootScope = rootScope;
        this._scope = scope;
        this._element = element[0];
        this._stickyMode = false;

        rootScope.$on(Constants.Events.WINDOW_SCROLL, ($event, scrollTop) => this._onScroll(scrollTop));
        rootScope.$on(Constants.Events.WINDOW_WIDTH_CHANGED, () => this._onWidthChanged());

        this._paddingElement = document.createElement("div");
        this._paddingElement.style.display = 'none';
        this._element.parentElement.insertBefore(this._paddingElement, this._element);

        this._element.className += ' sticky-panel';
    }

    _onScroll(scrollTop) {
        let element = this._stickyMode ? this._paddingElement : this._element;
        let top = 0;
        while (element) {
            top += element.offsetTop;
            element = element.offsetParent;
        }
        const stickyMode = top < scrollTop;
        if (stickyMode !== this._stickyMode) {
            this._stickyMode = stickyMode;
            const stickyPanelClass = ' sticky-panel-docked';
            if (stickyMode) {
                this._element.className += stickyPanelClass;
                this._paddingElement.style.display = 'block';
            } else {
                let pos = this._element.className.indexOf(stickyPanelClass);
                this._element.className = this._element.className.substring(0, pos) + this._element.className.substring(pos + stickyPanelClass.length);
                this._paddingElement.style.display = 'none';
            }
        }
    }

    _onWidthChanged() {
        this._paddingElement.style.height = this._element.clientHeight + 'px';
    }
}

module.directive('stickyPanel', ['$rootScope', function ($rootScope) {
    return {
        replace: false,
        scope: {
            inputFocus: '='
        },
        link: function ($scope, element) {
            new StickyPanelDirectiveController($scope, element, $rootScope);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/StickyPanelDirective.js